
import { Component, Vue, Prop } from 'vue-property-decorator';
import {
  CardButtons,
  ActionButtonList
} from '@/modules/common/components/cards/CardButtons';
import { GlobalSummaryUpdateToAccountRegulation } from '@/modules/common/services/graphql/server/server.sdk';
import { CustomerModule } from '@/modules/common/store/CustomerModule';
import { WarrenModules } from '@/types/navigation';

@Component({
  components: { CardButtons }
})
export default class UpdateAccountInbox extends Vue {
  @Prop({ type: Object, required: true })
  data!: GlobalSummaryUpdateToAccountRegulation;

  get descriptionPJ() {
    return `${this.data.description} Solicite a atualização cadastral através de cadastro@warren.com.br.`;
  }

  get button(): ActionButtonList[] {
    return [{ label: this.data.labelButton, action: 'onClick' }];
  }

  get description() {
    const capitalize = (str: string) =>
      str.charAt(0).toUpperCase() + str.slice(1);
    return capitalize(this.data.title);
  }

  private get isCustomerPJ() {
    return Boolean(CustomerModule.getCustomer?.professionalProfile);
  }

  goToRegulatoryUpdate() {
    this.$router.push({
      name: 'regulatory-update',
      query: { cameFrom: WarrenModules.Home }
    });
  }
}
